(() => {
  if (window.__imBundleToggleBound) return;
  window.__imBundleToggleBound = true;

  const setMode = (root, mode) => {
    const productInfo = root.closest('.product-info');
    if (productInfo) productInfo.dataset.purchaseMode = mode;

    root.querySelectorAll('[data-bundle-mode-btn]').forEach((btn) => {
      const isActive = btn.dataset.bundleModeBtn === mode;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive);
    });

    const bundlePanel = root.parentElement.querySelector('[data-bundle-panel="bundle"]');
    const individualPanel = root.parentElement.querySelector('[data-bundle-panel="individual"]');
    if (bundlePanel) bundlePanel.hidden = mode !== 'bundle';
    if (individualPanel) individualPanel.hidden = mode === 'bundle';
  };

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-bundle-mode-btn]');
    if (!btn) return;
    const root = btn.closest('[data-bundle-toggle]');
    if (!root) return;
    setMode(root, btn.dataset.bundleModeBtn);
  });
})();
